import _ from 'lodash';
import {
  useState,
  useEffect,
} from 'react';
import {
  qalBoxSaveGenre,
  qalBoxUpdateGenre
} from '../../services/mp-cf-api-service';

const genreCreate = () => {
  const [ responseData, setResponseData ] = useState({ });
  const [ updateData, setUpdateData ] = useState(null);
  const {
    items,
    onOperationComplete,
  } = updateData || {};

  const addGenreItem = async () => {
    try {
      console.log(`QalBox Genre Create...`);
      setResponseData({
        isUpdating: true,
        isError: false,
      });

      let mediaItemsAddUpdateApiResp = {data : {}};

      if(items.id){
        mediaItemsAddUpdateApiResp = await qalBoxUpdateGenre({
          media: items,
          language_code: _.get(items, '[0].language'),
        });
      }else{
        mediaItemsAddUpdateApiResp = await qalBoxSaveGenre({
          media: items,
          language_code: _.get(items, '[0].language'),
        });
      }

      const responseData = mediaItemsAddUpdateApiResp.data;

      let errorMsg = null;
      let isError = false;

      if(responseData.success) {
        console.log('QalBox media tag items add/update Success!!');
      } else {
        console.log('QalBox media tag items add/update Failed!!');
        errorMsg = `Failed to add/update QalBox media items.`;
        isError = true;
      }

      setResponseData({
        isUpdating: false,
        isError,
        errorMsg,
        data: responseData.payload,
      });

      if(onOperationComplete) {
        onOperationComplete({
          isError,
          errorMsg,
          data: responseData.payload,
        });
      }
    } catch (err) {
      console.log('Something went wrong while add/update QalBox media items. ', err);
      const errorMsg = `Error occurred while add/update QalBox media items.`;
      setResponseData({
        isUpdating: false,
        isError: true,
        errorMsg,
        data: null,
      });
      if(onOperationComplete) {
        onOperationComplete({
          isError: true,
          errorMsg,
          data: null,
        });
      }
    }
  };

  useEffect( () => {
    if(!_.isEmpty(updateData)) {
      addGenreItem();
    }
  }, [ updateData ]);

  return [
    responseData,
    setUpdateData,
  ];
};

export default genreCreate;
